class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);

document.addEventListener('DOMContentLoaded', function() {
  const desktopPlaceholder = 'Search for coffee, water, brew methods, etc…';
  const mobilePlaceholder = 'Search for…';

  function updatePlaceholders() {
    const inputs = document.querySelectorAll('.search__input');
    if (!inputs.length) return;

    inputs.forEach(input => {
      if (window.innerWidth <= 749) {
        input.placeholder = mobilePlaceholder;
      } else {
        input.placeholder = desktopPlaceholder;
      }
    });
  }

  // Run on load
  updatePlaceholders();

  // Run on resize
  window.addEventListener('resize', updatePlaceholders);

  // Re-run if Shopify dynamically loads content
  document.addEventListener('shopify:section:load', updatePlaceholders);
  document.addEventListener('shopify:section:unload', updatePlaceholders);
  document.addEventListener('shopify:section:select', updatePlaceholders);
  document.addEventListener('shopify:section:deselect', updatePlaceholders);
});
